namespace GeniuzPOS.Administration {
    export interface PsPosProcessModeForm {
        PosProcessMode: Serenity.StringEditor;
        PosProcessModeName: Serenity.StringEditor;
    }

    export class PsPosProcessModeForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PsPosProcessMode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPosProcessModeForm.init)  {
                PsPosProcessModeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsPosProcessModeForm, [
                    'PosProcessMode', w0,
                    'PosProcessModeName', w0
                ]);
            }
        }
    }
}
